import { styled } from '../../Utilities';
import { TextFieldBase } from './TextField.base';
import { getStyles } from './TextField.styles';
export var TextField = styled(TextFieldBase, getStyles, undefined, {
    scope: 'TextField',
});
//# sourceMappingURL=TextField.js.map